"use client";

import { AlarmClock } from "lucide-react";
import type { Notification } from "@/types/notification";
import NotificationItem, {
  NotificationPageLink,
} from "@/components/tailwind/notification/notificationItem";

export default function NotificationReminder({ notification }: { notification: Notification }) {
  return (
    <NotificationItem
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full border border-gray-300 text-gray-600 dark:border-gray-600 dark:text-gray-300">
          <AlarmClock className="h-3.5 w-3.5" />
        </div>
      }
      createdAt={notification.createdAt}
      unread={!notification.read}
      title="Reminder"
      message={
        <>
          in <NotificationPageLink noteId={notification.noteId} title={notification.noteTitle} />
          {notification.message && (
            <span className="mt-1 block whitespace-pre-wrap text-gray-500 dark:text-gray-400">
              {notification.message}
            </span>
          )}
        </>
      }
    />
  );
}
